import React, { useEffect, useState } from "react";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import SearchableSelect from "../SearchableSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import useApi from "../../Hooks/useApi";
import * as api from "../../api/getapi";
import ReactSelect from "../ReactSelect";
import style from "../../styles/MultiSelect.module.css";
import Select from "../Select";

export const VoucherConditions = ({ voucherConditions, setVoucherConditions }) => {
  const [filterInput, setFilterInput] = useState("");
  const fetchAllCities = useApi(api.getCitiess);
  const fetchListings = useApi(api.getListings);
  const dropdownShops = useApi(api.getDropdownShops);
  const fetchAllUsers = useApi(api.fetchAllMarketPlaceUsers);
  const PAYMENT_METHOD_OPTIONS = [
    // { value: "Bank Transfer", label: "Bank Transfer" },
    { value: "Cash", label: "Cash" },
    { value: "Card", label: "Card" },
    { value: "Card - BNPL", label: "Card - BNPL" },
    { value: "Raast", label: "Raast" },
  ];
  const CATEGORY_OPTIONS = [
    { value: "2", label: "Mobile" },
    { value: "3", label: "Tablet" },
    { value: "4", label: "TV / Monitor" },
    { value: "1", label: "Laptop" },
    { value: "5", label: "Desktop Computer" },
    { value: "6", label: "Accessories" },
  ];
  const loadCategories = async () => {
    return CATEGORY_OPTIONS;
  };

  const loadPaymentMethods = async (inputValue) => {
    // Filter options based on input for async select
    if (inputValue) {
      return PAYMENT_METHOD_OPTIONS.filter((option) => option.label.toLowerCase().includes(inputValue.toLowerCase()));
    }
    return PAYMENT_METHOD_OPTIONS;
  };

  const getAllCities = async (inputValue) => {
    try {
      const res = await fetchAllCities.request();

      const cityOptions = res?.data?.map((item) => ({
        label: item.city_name,
        value: item.city_id,
      }));

      // Filter options based on input for async select
      if (inputValue) {
        return cityOptions.filter((option) => option.label.toLowerCase().includes(inputValue.toLowerCase()));
      }
      return cityOptions;
    } catch (error) {
      console.log(error?.response?.data?.message || error);
      return [];
    }
  };
  useEffect(() => {
    getAllCities();
    fetchAllListings();
    fetchAllShops();
    fetchAllMarketplaceUsers();
  }, [voucherConditions?.condition_type]);

  const fetchAllListings = async (inputValue) => {
    try {
      const res = await fetchListings.request({ filter: inputValue || "" });
      const listingsOptions = res?.data?.data?.map((item) => ({
        label: item.title,
        value: item.id,
      }));
      // Filter options based on input for async select
      if (inputValue) {
        return listingsOptions.filter((option) => option.label.toLowerCase().includes(inputValue.toLowerCase()));
      }
      return listingsOptions;
    } catch (error) {
      console.log(error?.response?.data?.message || error);
      return [];
    }
  };

  const fetchAllShops = async (inputValue) => {
    try {
      const res = await dropdownShops.request();
      const shopOptions = res?.data?.map((cat) => ({
        label: "[" + cat.id + "] " + cat.shop_name,
        value: cat.id,
      }));
      // Filter options based on input for async select
      if (inputValue) {
        return shopOptions.filter((option) => option.label.toLowerCase().includes(inputValue.toLowerCase()));
      }
      return shopOptions;
    } catch (error) {
      console.log("err" + error);
      return [];
    }
  };
  const fetchAllMarketplaceUsers = async (inputValue) => {
    try {
      const res = await fetchAllUsers.request({ orderBy: "createdAt", order: "desc" });
      const shopOptions = res?.data?.data?.map((cat) => ({
        label: "[" + cat.uuid + "] " + cat.first_name + " " + cat.last_name,
        value: cat.uuid,
      }));
      // Filter options based on input for async select
      if (inputValue) {
        return shopOptions.filter((option) => option.label.toLowerCase().includes(inputValue.toLowerCase()));
      }
      return shopOptions;
    } catch (error) {
      console.log("err" + error);
      return [];
    }
  };

  const addRow = () => {
    if (voucherConditions.length >= 2) {
      return;
    }
    const newRow = {
      id: voucherConditions.length + 1,
      condition_type: "",
      operator: "",
      value: [],
    };
    setVoucherConditions([...voucherConditions, newRow]);
  };
  const deleteRow = (index) => {
    if (voucherConditions.length <= 1) {
      return;
    }
    let items = [...voucherConditions];
    items.splice(index, 1);
    setVoucherConditions(items);
  };

  const handleChange = (selected, index) => {
    setVoucherConditions((prev) => prev.map((item, i) => (i === index ? { ...item, value: selected } : item)));
  };

  // Get available condition type options for a specific row
  const getAvailableConditionTypes = (currentIndex) => {
    const allOptions = [
      { label: "city", value: "CITY" },
      { label: "category", value: "CATEGORY" },
      { label: "product", value: "PRODUCT" },
      { label: "user", value: "USER" },
      // { label: "user group", value: "USER_GROUP" },
      { label: "shop", value: "SHOP" },
      { label: "date range", value: "DATE_RANGE" },
      { label: "payment method", value: "PAYMENT_METHOD" },
      // { label: "min order", value: "MIN_ORDER" },
    ];

    // Get selected condition types from other rows
    const selectedTypes = voucherConditions.map((cond, idx) => idx !== currentIndex && cond.condition_type?.value).filter(Boolean);

    // Filter out already selected types
    return allOptions.filter((option) => !selectedTypes.includes(option.value));
  };

  // Determine if operator field should be disabled
  const isOperatorDisabled = (condition) => {
    if (!condition.condition_type?.value) return true;

    // For multiselect fields, check if value array has items
    const multiSelectTypes = ["CITY", "CATEGORY", "PRODUCT", "USER", "SHOP", "PAYMENT_METHOD"];
    if (multiSelectTypes.includes(condition.condition_type?.value)) {
      return !condition.value || condition.value.length === 0;
    }

    // For date range, require both FROM and TO
    if (condition.condition_type?.value === "DATE_RANGE") {
      const [from, to] = getDateRangeParts(condition.value);
      return !(from && to);
    }

    // For single value fields, check if value exists
    return !condition.value || condition.value === "";
  };

  // Get available operator options based on condition type
  const getOperatorOptions = (conditionType) => {
    const multiSelectTypes = ["CITY", "CATEGORY", "PRODUCT", "USER", "SHOP", "PAYMENT_METHOD"];

    // For multiselect, only show IN operator
    if (multiSelectTypes.includes(conditionType?.value)) {
      return [
        { label: "IN", value: "IN" },
        { label: "NOT_IN", value: "NOT_IN" },
      ];
    }

    // For other types, show all operators
    return [
      { label: "IN", value: "IN" },
      { label: "NOT_IN", value: "NOT_IN" },
      { label: "EQ", value: "EQ" },
      { label: "GTE", value: "GTE" },
      { label: "LTE", value: "LTE" },
      { label: "BETWEEN", value: "BETWEEN" },
    ];
  };

  // Helpers for comma-separated date range (FROM,TO)
  const getDateRangeParts = (value) => {
    if (!value) return ["", ""]; // [from, to]
    const parts = String(value?.value || value).split(",");
    return [parts[0] || "", parts[1] || ""];
  };

  const updateDateRange = (index, part, newVal) => {
    setVoucherConditions((prev) =>
      prev.map((item, i) => {
        if (i !== index) return item;
        const [from, to] = getDateRangeParts(item.value);
        const nextFrom = part === "from" ? newVal : from;
        const nextTo = part === "to" ? newVal : to;
        return { ...item, value: `${nextFrom},${nextTo}` };
      }),
    );
  };

  return (
    <>
      <h4>Voucher Conditions</h4>
      {voucherConditions.map((condition, index) => (
        <Row key={index} className="">
          <Col md={5} className="py-2">
            <Form.Group className="w-100" controlId="formBasicShopName">
              <label>
                Voucher Condition Type<span className="text-danger">*</span>
              </label>
              <SearchableSelect
                placeholder="Select Voucher Condition Type"
                value={condition.condition_type}
                name="condition_type"
                searchable={true}
                options={getAvailableConditionTypes(index)}
                handleChange={(e) => {
                  setVoucherConditions((prev) => prev.map((item, i) => (i === index ? { ...item, condition_type: e, operator: "", value: "" } : item)));
                }}
                required
              />
              <Form.Control.Feedback type="invalid">* Please Select Voucher Condition Type</Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6} className="py-2">
            <Form.Group className="w-100" controlId="formBasicShopName">
              <label>
                Voucher Condition Operator<span className="text-danger">*</span>
              </label>
              <SearchableSelect
                placeholder="Select Voucher Condition Operator"
                value={condition.operator}
                name="operator"
                searchable={true}
                options={getOperatorOptions(condition.condition_type)}
                handleChange={(e) => {
                  setVoucherConditions((prev) => prev.map((item, i) => (i === index ? { ...item, operator: e } : item)));
                }}
                disabled={isOperatorDisabled(condition)}
                required
              />
              <Form.Control.Feedback type="invalid">* Please Select Voucher Condition Operator</Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={1} className="py-2">
            {voucherConditions.length > 1 && (
              <div className="mt-4 text-decoration-underline text-danger cursor-pointer" onClick={() => deleteRow(index)}>
                Delete
              </div>
            )}
          </Col>

          {condition?.condition_type?.value === "CITY" ? (
            <Col className="py-2" md={6}>
              <Form.Group controlId="formBasicTiming" id="add-location-opening-days">
                <label className="mb-0">
                  Select Cities <span className="text-danger">*</span>
                </label>
                <div className={`${style.flexAlign} ${style.multiSelect} scrollable_multiselect`}>
                  <InputGroup hasValidation>
                    <ReactSelect
                      key={`city-${index}-${condition?.condition_type?.value}`}
                      classNamePrefix="react-select-container"
                      options={getAllCities}
                      multiselect={true}
                      closeMenuOnSelect={false}
                      components={{
                        Select,
                      }}
                      handleChange={(selected) => handleChange(selected, index)}
                      allowSelectAll={true}
                      value={condition.value}
                      styles={true}
                      cacheOptions={false}
                      name="value"
                    />
                  </InputGroup>
                </div>
                <Form.Control value={condition.value} hidden name="value" required />

                <Form.Control.Feedback type="invalid">Please Voucher Conditions Values </Form.Control.Feedback>
              </Form.Group>
            </Col>
          ) : condition?.condition_type?.value === "CATEGORY" ? (
            <Col className="py-2" md={6}>
              <Form.Group controlId="formBasicTiming" id="add-location-opening-days">
                <label className="mb-0">
                  Select Categories <span className="text-danger">*</span>
                </label>
                <div className={`${style.flexAlign} ${style.multiSelect} scrollable_multiselect`}>
                  <InputGroup hasValidation>
                    <ReactSelect
                      key={`category-${index}-${condition?.condition_type?.value}`}
                      classNamePrefix="react-select-container"
                      options={loadCategories}
                      multiselect={true}
                      closeMenuOnSelect={false}
                      components={{
                        Select,
                      }}
                      handleChange={(selected) => handleChange(selected, index)}
                      allowSelectAll={true}
                      value={condition.value}
                      styles={true}
                      cacheOptions={false}
                      name="value"
                    />
                  </InputGroup>
                </div>
                <Form.Control value={condition.value} hidden name="value" required />

                <Form.Control.Feedback type="invalid">Please Select Shop Opening Days </Form.Control.Feedback>
              </Form.Group>
            </Col>
          ) : condition?.condition_type?.value === "PRODUCT" ? (
            <Col className="py-2" md={6}>
              <Form.Group controlId="formBasicTiming" id="add-location-opening-days">
                <label className="mb-0">
                  Select Products <span className="text-danger">*</span>
                </label>
                <div className={`${style.flexAlign} ${style.multiSelect} scrollable_multiselect`}>
                  <InputGroup hasValidation>
                    <ReactSelect
                      key={`product-${index}-${condition?.condition_type?.value}`}
                      classNamePrefix="react-select-container"
                      options={fetchAllListings}
                      multiselect={true}
                      closeMenuOnSelect={false}
                      components={{
                        Select,
                      }}
                      handleChange={(selected) => handleChange(selected, index)}
                      allowSelectAll={true}
                      value={condition.value}
                      styles={true}
                      cacheOptions={false}
                      name="value"
                    />
                  </InputGroup>
                </div>
                <Form.Control value={condition.value} hidden name="value" required />

                <Form.Control.Feedback type="invalid">Please Select Products </Form.Control.Feedback>
              </Form.Group>
            </Col>
          ) : condition?.condition_type?.value === "USER" ? (
            <Col className="py-2" md={6}>
              <Form.Group controlId="formBasicTiming" id="add-location-opening-days">
                <label className="mb-0">
                  Select Users <span className="text-danger">*</span>
                </label>
                <div className={`${style.flexAlign} ${style.multiSelect} scrollable_multiselect`}>
                  <InputGroup hasValidation>
                    <ReactSelect
                      key={`user-${index}-${condition?.condition_type?.value}`}
                      classNamePrefix="react-select-container"
                      options={fetchAllMarketplaceUsers}
                      multiselect={true}
                      closeMenuOnSelect={false}
                      components={{
                        Select,
                      }}
                      handleChange={(selected) => handleChange(selected, index)}
                      allowSelectAll={true}
                      value={condition.value}
                      styles={true}
                      cacheOptions={false}
                      name="value"
                    />
                  </InputGroup>
                </div>
                <Form.Control value={condition.value} hidden name="value" required />

                <Form.Control.Feedback type="invalid">Please Select Users </Form.Control.Feedback>
              </Form.Group>
            </Col>
          ) : condition?.condition_type?.value === "SHOP" ? (
            <Col className="py-2" md={6}>
              <Form.Group controlId="formBasicTiming" id="add-location-opening-days">
                <label className="mb-0">
                  Select Shops <span className="text-danger">*</span>
                </label>
                <div className={`${style.flexAlign} ${style.multiSelect} scrollable_multiselect`}>
                  <InputGroup hasValidation>
                    <ReactSelect
                      key={`shop-${index}-${condition?.condition_type?.value}`}
                      classNamePrefix="react-select-container"
                      options={fetchAllShops}
                      multiselect={true}
                      closeMenuOnSelect={false}
                      components={{
                        Select,
                      }}
                      handleChange={(selected) => handleChange(selected, index)}
                      onInputChange={(newInput) => {
                        const inputValue = newInput.replace(/\W/g, "");
                        setFilterInput(inputValue);
                        return inputValue;
                      }}
                      allowSelectAll={true}
                      value={condition.value}
                      styles={true}
                      cacheOptions={false}
                      name="value"
                    />
                  </InputGroup>
                </div>
                <Form.Control value={condition.value} hidden name="value" required />

                <Form.Control.Feedback type="invalid">Please Select Shops </Form.Control.Feedback>
              </Form.Group>
            </Col>
          ) : condition?.condition_type?.value === "DATE_RANGE" ? (
            <>
              <Col md={6} className="py-2">
                <Form.Group className="w-100" controlId="formBasicShopName">
                  <label>Select TO Date </label>
                  <Form.Control
                    type="date"
                    value={getDateRangeParts(condition.value)[1]}
                    name="value"
                    onChange={(e) => {
                      updateDateRange(index, "to", e.target.value);
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={6} className="py-2">
                <Form.Group className="w-100" controlId="formBasicShopName">
                  <label>Select FROM Date </label>
                  <Form.Control
                    type="date"
                    value={getDateRangeParts(condition.value)[0]}
                    name="value"
                    onChange={(e) => {
                      updateDateRange(index, "from", e.target.value);
                    }}
                  />
                </Form.Group>
              </Col>
            </>
          ) : condition?.condition_type?.value === "PAYMENT_METHOD" ? (
            <Col className="py-2" md={6}>
              <Form.Group controlId="formBasicTiming" id="add-location-opening-days">
                <label className="mb-0">
                  Select Payment Methods <span className="text-danger">*</span>
                </label>
                <div className={`${style.flexAlign} ${style.multiSelect} scrollable_multiselect`}>
                  <InputGroup hasValidation>
                    <ReactSelect
                      key={`payment-method-${index}-${condition?.condition_type?.value}`}
                      classNamePrefix="react-select-container"
                      options={loadPaymentMethods}
                      multiselect={true}
                      closeMenuOnSelect={false}
                      components={{
                        Select,
                      }}
                      handleChange={(selected) => handleChange(selected, index)}
                      allowSelectAll={true}
                      value={condition.value}
                      styles={true}
                      cacheOptions={false}
                      name="value"
                    />
                  </InputGroup>
                </div>
                <Form.Control value={condition.value} hidden name="value" required />

                <Form.Control.Feedback type="invalid">Please Select Payment Methods </Form.Control.Feedback>
              </Form.Group>
            </Col>
          ) : condition?.condition_type?.value === "MIN_ORDER" ? (
            <Col md={6} className="py-2">
              <Form.Group className="w-100" controlId="formBasicShopName">
                <label>Minimum Order Amount </label>
                <Form.Control
                  type="number"
                  value={condition.value}
                  name="value"
                  onChange={(e) => {
                    setVoucherConditions((prev) => prev.map((item, i) => (i === index ? { ...item, value: e.target.value } : item)));
                  }}
                />
              </Form.Group>
            </Col>
          ) : (
            <></>
          )}
        </Row>
      ))}
      <Row className="text-end ">
        <Col>
          <Button onClick={addRow} variant="primary" size="sm" className="me-2" disabled={voucherConditions.length >= 2}>
            <span>Add More</span>
            <FontAwesomeIcon icon={faPlus} />
          </Button>
        </Col>
      </Row>
    </>
  );
};
